import React, { useState } from 'react';
import RefreshIcon from '@material-ui/icons/Refresh';

export default function EquipmentRefreshData({ handleRefreshData }) {
  // return { body };
  return (
    <div>
      <span
        onClick={handleRefreshData}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
        <RefreshIcon color={'primary'} fontSize={'small'} />
        &nbsp; &nbsp;
        <span
          style={{
            fontFamily: 'Roboto',
            fontWeight: '500',
            fontSize: '0.8125rem',
            color: '#26477c',
          }}>
          REFRESH
        </span>
      </span>
      {/* {body} */}
    </div>
  );
}
